// Third-party
import React from 'react';
import { FormattedMessage as ReactIntlFormattedMessage } from 'react-intl';

// Utils
import { formatMessageWithLocale } from './i18n';
import Dictionary from '@/types/dictionary';
import Locale from '@/types/locale';

const FormattedMessage = ({ locale, id, values, defaultMessage, tagName }: ReactIntlFormattedMessage.Props & { locale?: Locale }) => {
  if (locale) {
    return <span>{formatMessageWithLocale(id, locale, values as Dictionary<string | number>, defaultMessage)}</span>;
  }

  return <ReactIntlFormattedMessage id={id} values={values} defaultMessage={defaultMessage} tagName={tagName} />;
};

export default FormattedMessage;
